import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NafathVerificationService } from './service/nafath-verification.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-nafath-verification',
  templateUrl: './nafath-verification.component.html',
  styleUrls: ['./nafath-verification.component.scss'],
})
export class NafathVerificationComponent implements OnInit {
  isLoading = false;
  reference = this.route.snapshot.params['reference'];
  isVerificationSuccess = false;
  transId: string = '';
  random: string = '';

  constructor(
    protected translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private nafathVerificationService: NafathVerificationService,
    private readonly toaster: ToastrService
  ) {}

  ngOnInit(): void {
    this.getNafathVerificationNumber();
  }

  getNafathVerificationNumber() {
    this.isLoading = true;
    this.nafathVerificationService
      .getVerificationNumber(this.reference)
      .subscribe({
        next: (response) => {
          this.isLoading = false;

          if (response.succeeded) {
            this.transId = response.data.transId;
            this.random = response.data.random;
          } else {
            if (response.code === 1016) {
              this.router.navigate([
                `/${this.translate.currentLang}/verification-succeeded`,
              ]);

              return;
            }
            this.viewErrorToaster(response.message);
          }
        },
        error: () => {
          this.isLoading = false;
          this.handleGetCodeError();
        },
      });
  }

  handleGetCodeError() {
    this.router.navigate([`/${this.translate.currentLang}/not-found`]);
  }

  verifyNafath() {
    this.isLoading = true;
    this.nafathVerificationService
      .checkIsNafathVerificationSuccess(
        this.reference,
        this.transId,
        this.random
      )
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          if (response.succeeded) {
            document.body.classList.add('no-scroll');
            this.isVerificationSuccess = true;
          } else {
            this.viewErrorToaster(response.message);
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.viewErrorToaster(error.error?.message);
        },
      });
  }

  viewErrorToaster(errorMessage: string) {
    this.toaster.error(errorMessage);
  }
}
